import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=0cd48398&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "./platform.vue?vue&type=style&index=0&id=0cd48398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd48398",
  null
  
)

export default component.exports